module.exports = __webpack_public_path__ + "img/IC_Jefe.d2a379fa.png";